import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { HeadlineXS } from '@sorare/core/src/atoms/typography';

const Root = styled.div`
  margin-bottom: 20px;
`;

export const ResultCount = ({ count }: { count: number }) => {
  return (
    <Root>
      <HeadlineXS as="h6">
        <FormattedMessage
          id="ResultCount.count"
          defaultMessage="{count, plural, one {# Result found} other {# Results found}}"
          values={{ count }}
        />
      </HeadlineXS>
    </Root>
  );
};
